import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { Plus, Pencil, Trash2, X, Check, RefreshCw, Copy, ChevronDown, ChevronRight, Radio, Map } from 'lucide-react';

const PRIORIDADES = ['baja','media','alta','critica'];
const PRIORIDAD_COLORS = { baja:'var(--success)', media:'var(--warning)', alta:'#ff6b00', critica:'var(--danger)' };

export default function WebhookProveedoresPage() {
  const [proveedores, setProveedores] = useState([]);
  const [tiposEvento, setTiposEvento] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandido, setExpandido] = useState(null);
  const [showModalProveedor, setShowModalProveedor] = useState(false);
  const [showModalMapeo, setShowModalMapeo] = useState(false);
  const [editProveedor, setEditProveedor] = useState(null);
  const [editMapeo, setEditMapeo] = useState(null);
  const [proveedorActivo, setProveedorActivo] = useState(null);

  const [formProveedor, setFormProveedor] = useState({
    nombre:'', descripcion:'',
    campo_imei:'imei', campo_tipo:'type', campo_descripcion:'desc',
    campo_lat:'lat', campo_lng:'lng', campo_velocidad:'speed',
    campo_fecha:'dt_tracker', campo_placas:''
  });

  const [formMapeo, setFormMapeo] = useState({
    tipo_evento_id:'', valor_tipo:'', patron_descripcion:'',
    descripcion_legible:'', prioridad_override:'', activo:true
  });

  const fetchProveedores = async () => {
    setLoading(true);
    try {
      const res = await api.get('/webhook-proveedores');
      setProveedores(res.data.data);
    } catch(e) { toast.error('Error al cargar proveedores'); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetchProveedores();
    api.get('/catalogos/tipos-evento').then(r => setTiposEvento(r.data.data)).catch(()=>{});
  }, []);

  const openCrearProveedor = () => {
    setFormProveedor({ nombre:'', descripcion:'', campo_imei:'imei', campo_tipo:'type',
      campo_descripcion:'desc', campo_lat:'lat', campo_lng:'lng', campo_velocidad:'speed',
      campo_fecha:'dt_tracker', campo_placas:'' });
    setEditProveedor(null);
    setShowModalProveedor(true);
  };

  const openEditarProveedor = (p) => {
    setFormProveedor({ nombre:p.nombre, descripcion:p.descripcion||'',
      campo_imei:p.campo_imei, campo_tipo:p.campo_tipo, campo_descripcion:p.campo_descripcion,
      campo_lat:p.campo_lat, campo_lng:p.campo_lng, campo_velocidad:p.campo_velocidad,
      campo_fecha:p.campo_fecha, campo_placas:p.campo_placas||'' });
    setEditProveedor(p);
    setShowModalProveedor(true);
  };

  const handleGuardarProveedor = async (e) => {
    e.preventDefault();
    try {
      if (editProveedor) {
        await api.put(`/webhook-proveedores/${editProveedor.id}`, formProveedor);
        toast.success('Proveedor actualizado');
      } else {
        await api.post('/webhook-proveedores', formProveedor);
        toast.success('Proveedor creado');
      }
      setShowModalProveedor(false);
      fetchProveedores();
    } catch(e) { toast.error(e.response?.data?.message || 'Error'); }
  };

  const handleRegenerarToken = async (p) => {
    if (!window.confirm('¿Regenerar token? La URL anterior dejará de funcionar.')) return;
    try {
      await api.post(`/webhook-proveedores/${p.id}/regenerar-token`);
      toast.success('Token regenerado');
      fetchProveedores();
    } catch(e) { toast.error('Error'); }
  };

  const handleEliminarProveedor = async (p) => {
    if (!window.confirm(`¿Desactivar el proveedor "${p.nombre}"?`)) return;
    try {
      await api.delete(`/webhook-proveedores/${p.id}`);
      toast.success('Proveedor desactivado');
      fetchProveedores();
    } catch(e) { toast.error('Error'); }
  };

  const openAgregarMapeo = (proveedor) => {
    setProveedorActivo(proveedor);
    setFormMapeo({ tipo_evento_id:'', valor_tipo:'', patron_descripcion:'', descripcion_legible:'', prioridad_override:'', activo:true });
    setEditMapeo(null);
    setShowModalMapeo(true);
  };

  const openEditarMapeo = (proveedor, mapeo) => {
    setProveedorActivo(proveedor);
    setFormMapeo({
      tipo_evento_id: mapeo.tipo_evento_id,
      valor_tipo: mapeo.valor_tipo,
      patron_descripcion: mapeo.patron_descripcion || '',
      descripcion_legible: mapeo.descripcion_legible || '',
      prioridad_override: mapeo.prioridad_override || '',
      activo: mapeo.activo
    });
    setEditMapeo(mapeo);
    setShowModalMapeo(true);
  };

  const handleGuardarMapeo = async (e) => {
    e.preventDefault();
    try {
      const body = { ...formMapeo };
      if (!body.prioridad_override) delete body.prioridad_override;
      if (editMapeo) {
        await api.put(`/webhook-proveedores/${proveedorActivo.id}/mapeos/${editMapeo.id}`, body);
        toast.success('Mapeo actualizado');
      } else {
        await api.post(`/webhook-proveedores/${proveedorActivo.id}/mapeos`, body);
        toast.success('Mapeo agregado');
      }
      setShowModalMapeo(false);
      fetchProveedores();
    } catch(e) { toast.error(e.response?.data?.message || 'Error'); }
  };

  const handleEliminarMapeo = async (proveedor, mapeo) => {
    if (!window.confirm('¿Eliminar este mapeo?')) return;
    try {
      await api.delete(`/webhook-proveedores/${proveedor.id}/mapeos/${mapeo.id}`);
      toast.success('Mapeo eliminado');
      fetchProveedores();
    } catch(e) { toast.error('Error'); }
  };

  const copiar = (texto) => {
    navigator.clipboard.writeText(texto);
    toast.success('Copiado al portapapeles');
  };

  const webhookUrl = (token) => `${window.location.protocol}//${window.location.hostname}/api/webhook/alerta/${token}`;

  const fp = (k) => (e) => setFormProveedor(p => ({...p, [k]: e.target.value}));
  const fm = (k) => (e) => setFormMapeo(p => ({...p, [k]: e.target.value}));

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Proveedores GPS / Webhook</div>
          <div className="page-subtitle">Configura múltiples proveedores y mapeo de eventos</div>
        </div>
        <button className="btn btn-primary" onClick={openCrearProveedor}><Plus size={14}/> Nuevo Proveedor</button>
      </div>

      {loading ? <div className="loading-screen"><div className="spinner"/></div> : (
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          {proveedores.length === 0 && (
            <div className="card"><div className="table-empty">Sin proveedores configurados. Crea el primero.</div></div>
          )}

          {proveedores.map(p => (
            <div key={p.id} className="card">
              {/* Header del proveedor */}
              <div style={{ padding:'16px 20px', display:'flex', alignItems:'center', gap:12, borderBottom: expandido===p.id ? '1px solid var(--border)' : 'none' }}>
                <button onClick={() => setExpandido(expandido===p.id ? null : p.id)} style={{ background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer', padding:0 }}>
                  {expandido===p.id ? <ChevronDown size={16}/> : <ChevronRight size={16}/>}
                </button>
                <div style={{ display:'flex', alignItems:'center', gap:8, flex:1 }}>
                  <Radio size={16} color="var(--accent)"/>
                  <div>
                    <div style={{ fontFamily:'var(--font-display)', fontSize:15, fontWeight:700 }}>{p.nombre}</div>
                    {p.descripcion && <div style={{ fontSize:11, color:'var(--text-muted)' }}>{p.descripcion}</div>}
                  </div>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ textAlign:'right' }}>
                    <div style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-mono)' }}>
                      {p.total_eventos || 0} eventos recibidos
                    </div>
                    <div style={{ fontSize:11, color:'var(--text-muted)' }}>
                      {p.mapeos?.length || 0} mapeos configurados
                    </div>
                  </div>
                  <span style={{ display:'flex', alignItems:'center', gap:4 }}>
                    <span style={{ width:6, height:6, borderRadius:'50%', background:p.activo?'var(--success)':'var(--danger)' }}/>
                    <span style={{ fontSize:11, color:p.activo?'var(--success)':'var(--text-muted)' }}>{p.activo?'Activo':'Inactivo'}</span>
                  </span>
                  <div style={{ display:'flex', gap:6 }}>
                    <button className="btn-icon" onClick={() => openEditarProveedor(p)} title="Editar"><Pencil size={13}/></button>
                    <button className="btn-icon" onClick={() => handleEliminarProveedor(p)} title="Desactivar" style={{ color:'var(--danger)' }}><Trash2 size={13}/></button>
                  </div>
                </div>
              </div>

              {/* Detalle expandido */}
              {expandido === p.id && (
                <div style={{ padding:'20px' }}>

                  {/* URL del Webhook */}
                  <div style={{ marginBottom:20, padding:16, background:'var(--bg-elevated)', borderRadius:'var(--radius)', border:'1px solid var(--border)' }}>
                    <div className="form-label" style={{ marginBottom:8 }}>URL del Webhook para este proveedor</div>
                    <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                      <input className="form-control font-mono" readOnly value={webhookUrl(p.token)} style={{ fontSize:11, flex:1 }}/>
                      <button className="btn btn-secondary btn-sm" onClick={() => copiar(webhookUrl(p.token))}><Copy size={12}/> Copiar</button>
                      <button className="btn btn-secondary btn-sm" onClick={() => handleRegenerarToken(p)} title="Regenerar token"><RefreshCw size={12}/> Nuevo token</button>
                    </div>
                    <div style={{ fontSize:11, color:'var(--text-muted)', marginTop:6 }}>
                      Método: <strong>POST</strong> &nbsp;|&nbsp; Content-Type: <strong>application/json</strong> &nbsp;|&nbsp; Sin autenticación adicional requerida
                    </div>
                  </div>

                  {/* Configuración de campos */}
                  <div style={{ marginBottom:20 }}>
                    <div style={{ fontSize:12, fontFamily:'var(--font-display)', fontWeight:600, letterSpacing:0.5, textTransform:'uppercase', color:'var(--text-secondary)', marginBottom:10 }}>
                      Mapeo de Campos del Payload
                    </div>
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(160px,1fr))', gap:8 }}>
                      {[
                        ['IMEI/ID Dispositivo', p.campo_imei],
                        ['Tipo de Evento', p.campo_tipo],
                        ['Descripción', p.campo_descripcion],
                        ['Latitud', p.campo_lat],
                        ['Longitud', p.campo_lng],
                        ['Velocidad', p.campo_velocidad],
                        ['Fecha/Hora', p.campo_fecha],
                        ['Placas', p.campo_placas || '—'],
                      ].map(([label, val]) => (
                        <div key={label} style={{ background:'var(--bg-base)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:'8px 10px' }}>
                          <div style={{ fontSize:9, color:'var(--text-muted)', fontFamily:'var(--font-mono)', letterSpacing:1, textTransform:'uppercase' }}>{label}</div>
                          <div style={{ fontSize:12, fontFamily:'var(--font-mono)', color:'var(--accent)', marginTop:2 }}>{val}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Mapeos de eventos */}
                  <div>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
                      <div style={{ fontSize:12, fontFamily:'var(--font-display)', fontWeight:600, letterSpacing:0.5, textTransform:'uppercase', color:'var(--text-secondary)' }}>
                        Mapeo de Tipos de Evento ({p.mapeos?.length || 0})
                      </div>
                      <button className="btn btn-primary btn-sm" onClick={() => openAgregarMapeo(p)}><Plus size={12}/> Agregar Mapeo</button>
                    </div>

                    {(!p.mapeos || p.mapeos.length === 0) && (
                      <div style={{ padding:'24px', textAlign:'center', color:'var(--text-muted)', fontSize:12, fontFamily:'var(--font-mono)', background:'var(--bg-base)', borderRadius:'var(--radius)', border:'1px dashed var(--border)' }}>
                        Sin mapeos configurados — los eventos no serán clasificados correctamente
                      </div>
                    )}

                    {p.mapeos && p.mapeos.length > 0 && (
                      <div className="table-wrap">
                        <table>
                          <thead>
                            <tr>
                              <th>Valor Tipo (GPS)</th>
                              <th>Patrón Descripción</th>
                              <th>Descripción Legible</th>
                              <th>Tipo en Sistema</th>
                              <th>Prioridad</th>
                              <th>Estado</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {p.mapeos.map(m => (
                              <tr key={m.id}>
                                <td><span className="font-mono" style={{ fontSize:12, color:'var(--accent)' }}>{m.valor_tipo}</span></td>
                                <td style={{ fontSize:11, color:'var(--text-muted)' }}>{m.patron_descripcion || <span style={{color:'var(--text-muted)'}}>— cualquiera —</span>}</td>
                                <td style={{ fontSize:12 }}>{m.descripcion_legible || '—'}</td>
                                <td>
                                  <span style={{ display:'flex', alignItems:'center', gap:6, fontSize:12 }}>
                                    {m.tipoEvento?.color && <span style={{ width:8, height:8, borderRadius:'50%', background:m.tipoEvento.color, flexShrink:0 }}/>}
                                    {m.tipoEvento?.nombre || '—'}
                                  </span>
                                </td>
                                <td>
                                  {m.prioridad_override ? (
                                    <span className={`badge badge-${m.prioridad_override}`}>{m.prioridad_override}</span>
                                  ) : (
                                    <span style={{ fontSize:11, color:'var(--text-muted)' }}>Del catálogo</span>
                                  )}
                                </td>
                                <td>
                                  <span style={{ display:'flex', alignItems:'center', gap:4 }}>
                                    <span style={{ width:6, height:6, borderRadius:'50%', background:m.activo?'var(--success)':'var(--danger)' }}/>
                                    <span style={{ fontSize:11 }}>{m.activo?'Activo':'Inactivo'}</span>
                                  </span>
                                </td>
                                <td>
                                  <div style={{ display:'flex', gap:6 }}>
                                    <button className="btn-icon" onClick={() => openEditarMapeo(p, m)}><Pencil size={12}/></button>
                                    <button className="btn-icon" onClick={() => handleEliminarMapeo(p, m)} style={{ color:'var(--danger)' }}><Trash2 size={12}/></button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Modal Proveedor */}
      {showModalProveedor && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth:620 }}>
            <div className="modal-header">
              <span className="modal-title">{editProveedor ? 'Editar' : 'Nuevo'} Proveedor GPS</span>
              <button className="btn-icon" onClick={() => setShowModalProveedor(false)}><X size={16}/></button>
            </div>
            <form onSubmit={handleGuardarProveedor}>
              <div className="modal-body">
                <div className="grid-2">
                  <div className="form-group" style={{ gridColumn:'1/-1' }}>
                    <label className="form-label">Nombre del Proveedor *</label>
                    <input className="form-control" value={formProveedor.nombre} onChange={fp('nombre')} required placeholder="Ej: Wialon, GPS Tracker Pro..."/>
                  </div>
                  <div className="form-group" style={{ gridColumn:'1/-1' }}>
                    <label className="form-label">Descripción</label>
                    <input className="form-control" value={formProveedor.descripcion} onChange={fp('descripcion')} placeholder="Descripción opcional"/>
                  </div>
                </div>

                <div style={{ padding:'12px 0 8px', borderTop:'1px solid var(--border)', marginTop:4 }}>
                  <div style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-mono)', letterSpacing:1, textTransform:'uppercase', marginBottom:12 }}>
                    Nombres de campos en el payload JSON del proveedor
                  </div>
                  <div className="grid-3">
                    {[
                      ['campo_imei','IMEI / ID Dispositivo','imei'],
                      ['campo_tipo','Tipo de Evento','type'],
                      ['campo_descripcion','Descripción','desc'],
                      ['campo_lat','Latitud','lat'],
                      ['campo_lng','Longitud','lng'],
                      ['campo_velocidad','Velocidad','speed'],
                      ['campo_fecha','Fecha / Hora','dt_tracker'],
                      ['campo_placas','Placas (opcional)','plate_number'],
                    ].map(([key, label, placeholder]) => (
                      <div key={key} className="form-group">
                        <label className="form-label">{label}</label>
                        <input className="form-control font-mono" style={{ fontSize:12 }} value={formProveedor[key]} onChange={fp(key)} placeholder={placeholder}/>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModalProveedor(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary"><Check size={14}/> Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Mapeo */}
      {showModalMapeo && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth:540 }}>
            <div className="modal-header">
              <span className="modal-title">{editMapeo ? 'Editar' : 'Nuevo'} Mapeo de Evento</span>
              <button className="btn-icon" onClick={() => setShowModalMapeo(false)}><X size={16}/></button>
            </div>
            <form onSubmit={handleGuardarMapeo}>
              <div className="modal-body">
                <div style={{ padding:'10px 12px', background:'var(--accent-glow)', border:'1px solid var(--border)', borderRadius:'var(--radius)', fontSize:12, color:'var(--text-secondary)', marginBottom:16 }}>
                  <strong style={{ color:'var(--accent)' }}>Proveedor:</strong> {proveedorActivo?.nombre}<br/>
                  Define cómo se identifica un evento del GPS y a qué tipo del catálogo corresponde.
                </div>

                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">Valor del Campo Tipo (GPS) *</label>
                    <input className="form-control font-mono" value={formMapeo.valor_tipo} onChange={fm('valor_tipo')} required placeholder="Ej: stopped, speeding, sos" style={{ fontSize:12 }}/>
                    <div style={{ fontSize:10, color:'var(--text-muted)', marginTop:3 }}>Exactamente como lo manda el proveedor</div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Patrón en Descripción (opcional)</label>
                    <input className="form-control" value={formMapeo.patron_descripcion} onChange={fm('patron_descripcion')} placeholder="Ej: ZONA DE RIESGO"/>
                    <div style={{ fontSize:10, color:'var(--text-muted)', marginTop:3 }}>Para distinguir subtipos del mismo tipo</div>
                  </div>
                  <div className="form-group" style={{ gridColumn:'1/-1' }}>
                    <label className="form-label">Descripción Legible en el Sistema</label>
                    <input className="form-control" value={formMapeo.descripcion_legible} onChange={fm('descripcion_legible')} placeholder="Ej: Parada en Zona de Riesgo"/>
                    <div style={{ fontSize:10, color:'var(--text-muted)', marginTop:3 }}>Texto amigable que verá el monitorista</div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Tipo de Evento del Catálogo *</label>
                    <select className="form-control" value={formMapeo.tipo_evento_id} onChange={fm('tipo_evento_id')} required>
                      <option value="">Seleccionar...</option>
                      {tiposEvento.map(t => (
                        <option key={t.id} value={t.id}>{t.nombre}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Prioridad (opcional)</label>
                    <select className="form-control" value={formMapeo.prioridad_override} onChange={fm('prioridad_override')}>
                      <option value="">Usar la del catálogo</option>
                      {PRIORIDADES.map(p => <option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
                    </select>
                  </div>
                </div>

                <div style={{ padding:12, background:'var(--bg-elevated)', borderRadius:'var(--radius)', fontSize:11, color:'var(--text-muted)', marginTop:4 }}>
                  <strong style={{ color:'var(--text-secondary)' }}>Ejemplo:</strong> Si el GPS manda <span className="font-mono" style={{ color:'var(--accent)' }}>"type":"stopped"</span> con <span className="font-mono" style={{ color:'var(--accent)' }}>"desc":"PARADO EN ZONA DE RIESGO"</span>,
                  crea un mapeo con valor <strong>stopped</strong>, patrón <strong>ZONA DE RIESGO</strong> y asígnalo al tipo <strong>Motor Apagado en Zona Insegura</strong>.
                  Para otras paradas sin patrón, crea otro mapeo con valor <strong>stopped</strong> sin patrón.
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModalMapeo(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary"><Check size={14}/> Guardar Mapeo</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
